// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"az_O5b"};